import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ArrowLeft } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  path?: string;
  isActive?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  showBackButton?: boolean;
  backButtonText?: string;
  backButtonPath?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  className = '',
  showBackButton = false,
  backButtonText = 'Back',
  backButtonPath,
}) => {
  // If we only have one item and showBackButton is true, show a simple back button
  if (items.length === 1 && showBackButton) {
    const backPath = backButtonPath || items[0].path || '/';
    return (
      <nav className={`flex items-center space-x-2 mb-6 ${className}`}>
        <Link
          to={backPath}
          className="inline-flex items-center text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {backButtonText}
        </Link>
      </nav>
    );
  }

  // Show full breadcrumb navigation
  return (
    <nav className={`flex items-center space-x-2 mb-6 ${className}`} aria-label="Breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <ChevronRight className="w-4 h-4 text-gray-600" />
          )}

          {item.isActive || !item.path ? (
            <span className={`font-medium ${item.isActive ? 'text-primary' : 'text-white'}`}>
              {item.label}
            </span>
          ) : (
            <Link
              to={item.path}
              className="text-gray-400 hover:text-primary transition-colors"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;